import React, {PureComponent} from 'react';
import {connect} from 'react-redux';
import PropTypes from "prop-types";

import {
  getAllFilterGroups, getFiltersListFromFeaturesArray,
  getFilterValuesByGroup, setExpandedFilters,
  setFeaturesGroupAvailableFilters,
  setFilterVisible, setSelectedFilters
} from "./FeaturesFiltersActions";
import FeaturesFiltersBodyContent from "./FeaturesFiltersBodyContent";
import {getAuthSubDomain} from "../../../constants/fabricatorHardcode";

class FeaturesFiltersBody extends PureComponent {

  constructor(props) {
    super(props);
    this.state = {
      // isLoading: true,
      filterButtons: ["Others", "Materials", "Brand", "Color"]
    };
    this._isMounted = false;
  }

  componentDidMount() {
    this._isMounted = true;
    this.setAvailableFiltersValues();
  }

  componentWillUnmount() {
    this._isMounted = false;
    if (this.props.forFeatures) {
      this.props.setFeaturesGroupAvailableFilters(this.props.activeFeaturesGroupName, null);
    }
  }

  setAvailableFiltersValues() {
    const requests = [];
    if (!this.props.allFilterGroups.length) {
      requests.push(getAllFilterGroups());
    }
    if (!this.props.filtersReceived[this.props.activeFeaturesGroupName] && !this.props.forFeatures) {
      requests.push(getFilterValuesByGroup(this.props.activeFeaturesGroupName, null, this.props.featuresSetupPage, this.props.forFabricatorId));
    }
    Promise.all(requests).then((response) => {
      if (this._isMounted) {
        // this.setState({
        //   isLoading: false
        // })
      }
      // let allFilterGroups = (response.length === 2) ? response[0].filterGroups : this.props.allFilterGroups;
      // const groupName = this.props.activeFeaturesGroupName;
      // const countertopGroup = ["Countertop", "Center Island Countertop", "Backsplash"];
      // let filterValuesArray = Array.isArray(response) ? response : [];
      // if (countertopGroup.includes(groupName) && filterValuesArray) {
      //   const availableCountertopGroupFilters = ["Stone Color", "Manufacturer", "Countertop Material"];
      //   if (countertopGroup === "Backsplash") {
      //     availableCountertopGroupFilters.push("Material");
      //   }
      //   allFilterGroups = allFilterGroups.filter(filterGroup => {
      //     return filterGroup && filterGroup.name && availableCountertopGroupFilters.includes(filterGroup.name.trim())
      //   });
      //   filterValuesArray = filterValuesArray.filter(filterId => {
      //     return allFilterGroups.some(filterGroup => filterGroup.values && filterGroup.values.some(filterValueObject => {
      //       return filterValueObject.id === filterId
      //     }))
      //   });
      //   this.props.setFeaturesGroupAvailableFilters(groupName, filterValuesArray);
      // }
      if (this.props.forFeatures) {
        const subDomain = getAuthSubDomain(this.props.auth, this.props.asCustomer);
        const filterValuesArray = getFiltersListFromFeaturesArray(this.props.forFeatures, [], subDomain);
        this.props.setFeaturesGroupAvailableFilters(this.props.activeFeaturesGroupName, filterValuesArray);
      }
    });
  }

  handleGroupClick = (filterName) => {
    if (this.props.filterVisible === filterName && this.props.useDropdown) {
      this.props.setFilterVisible("");
    } else if (this.props.filterVisible !== filterName) {
      this.props.setFilterVisible(filterName);
    }
  };

  handleReset = () => {
    this.props.setSelectedFilters([]);
    this.props.setExpandedFilters([]);
  };

  render() {
    const {featuresSetupPage, featuresListReceived} = this.props;
    if (featuresSetupPage && !featuresListReceived) {
      return <div className="ui-loader"/>
    }
    const filtersReceived = this.props.filtersReceived[this.props.activeFeaturesGroupName];
    return filtersReceived && this.props.allFilterGroups.length ? (
      <div className={"filters-container__popup" + (this.props.filterVisible ? " filters-container__popup--visible" : "")}>
        <div className="filters-header">
          {this.state.filterButtons.map((filterName) => {
            const filterGroup = this.props.allFilterGroups.find(group => group.name === filterName);
            const buttonText = (filterName === "Others") ? "+Filters" : filterName;
            const filterNameLowerCased = filterName.toLowerCase();
            let buttonEnabled = false;
            if (filterName === "Others") {
              buttonEnabled = Array.isArray(filtersReceived) && this.props.allFilterGroups.some(filterGroup => {
                return !["Materials", "Brand", "Color"].includes(filterGroup.name) && filterGroup.values.some(filterValue => {
                  return filtersReceived.includes(filterValue.id);
                })
              });
            } else {
              buttonEnabled = filterGroup && (Array.isArray(filtersReceived) && filterGroup.values.some(filterValue => {
                return filtersReceived.includes(filterValue.id);
              }));
            }
            return (
              <div key={filterName}
                   onClick={() => this.handleGroupClick(filterName)}
                   className={"filters-header-icon filters-header-icon--"+filterNameLowerCased
                   + (this.props.filterVisible === filterName ? " filters-header-icon--active filters-header-icon--active--"+filterNameLowerCased : "")
                   + (!buttonEnabled ? " filters-header-icon--disabled" : "")}>
                {buttonText}
              </div>
            )
          })}
          <div className="filters-header-icon filters-header-icon--reset" onClick={this.handleReset}>
            <span className="filters-header-icon--reset-title">Reset</span>
          </div>
        </div>
        <div className="filters-body">
          <FeaturesFiltersBodyContent featureGroupName={this.props.featureGroupName}/>
        </div>
      </div>
    ) : <div className="ui-loader"/>
  }
}

FeaturesFiltersBody.propTypes = {
  useDropdown: PropTypes.bool,
  featuresSetupPage: PropTypes.bool,
  featureGroupName: PropTypes.string,
  forFabricatorId: PropTypes.number,
  forFeatures: PropTypes.array,
}

const mapStateToProps = (store, ownProps) => {
  const {featuresListReceived} = store.featuresSetupState;
  const {auth, asCustomer} = store;
  return {
    activeFeaturesGroupName: ownProps.featureGroupName || store.featuresCreatorNew.activeFeaturesGroupName,
    allFilterGroups: store.featuresFiltersState.allFilterGroups,
    filtersReceived: store.featuresFiltersState.filtersReceived,
    filterVisible: store.featuresFiltersState.filterVisible,
    featuresListReceived,
    auth,
    asCustomer,
  };
};

const mapDispatchToProps = {
  setFeaturesGroupAvailableFilters,
  setFilterVisible,
  setSelectedFilters,
  setExpandedFilters
};
export default connect(mapStateToProps, mapDispatchToProps)(FeaturesFiltersBody);
